<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/job/details/', invoices.project_id, invoices.job_id]">Zum Job</a>
    </li>
  </ul>
</nav>

<main *ngIf="!!invoices">
  <h2>
    <ng-container *ngIf="invoices.cancels_invoice_no">STORNORECHNUNG</ng-container>
    <ng-container *ngIf="!invoices.cancels_invoice_no">Rechnung</ng-container>
    {{ invoices.praefix }}.{{ invoices.number }}
  </h2>
  <div class="alert alert-warning" role="alert" *ngIf="invoices.cancels_invoice_no">
    <div class="alert-items">
      <div class="alert-item static">
        <div class="alert-icon-wrapper"><cds-icon class="alert-icon" shape="exclamation-triangle"></cds-icon></div>
        <span class="alert-text">Stornorechnung zu Rechnung {{ invoices.cancels_invoice_no }}</span>
      </div>
    </div>
  </div>
  <p *ngIf="!loading1">
    <span class="label label-light-blue">Rechnung vom: {{ invoices.dateI | date:'dd.MM.yyyy'  }}</span>
    <span class="label label-light-blue">Rechnung fällig am: {{ invoices.dateII | date:'dd.MM.yyyy'  }}</span>
    <span class="label label-light-blue">Job: {{ invoices.project_id + '.0006.' + invoices.job_id }}</span>
    <span class="label {{ statusLabel }}">Status: {{ statusText }}</span>
  </p>

  <div class="spinner" *ngIf="loading1">Loading data</div>
  <div class="clr-row" *ngIf="!loading1">
    <div class="clr-col-lg-12 clr-col-md-12 clr-col-12">
      <div *ngIf="!!job" class="card">
        <div class="card-header">
          {{ invoices.name_project }}
        </div>
        <div class="card-block">
          <div class="card-text">
            <clr-tabs>
              <clr-tab>
                <button clrTabLink>Übersicht</button>
                <clr-tab-content clrTabContentId="content1" *clrIfActive="true">
                  <br>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      Rechnungsempfänger
                    </div>
                    <div class="clr-col-9">
                      {{ invoices.company_name }}<br /><span *ngIf="invoices.department">{{ invoices.department }} <br /></span> {{ invoices.street }}<br />{{ invoices.postcode }} {{ invoices.city }}
                      <span *ngIf="invoices.country !== 'Deutschland'">{{ invoices.country }}</span>
                    </div>
                  </div>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      <br />Lieferung an
                    </div>
                    <div class="clr-col-9">
                      <br />{{ job.delivery_company }}<br /><span *ngIf="job.delivery_department">{{ job.delivery_department }} <br /></span> {{ job.delivery_street }}<br />{{ job.delivery_postcode }} {{ job.delivery_city }}
                      <span *ngIf="job.delivery_country !== 'Deutschland'">{{ job.delivery_country }}</span>
                    </div>
                  </div>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      <br />Kundenbestellung
                    </div>
                    <div class="clr-col-9"><br />{{ invoices.order_id }}</div>
                  </div>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      <br />Zahlungsbedingungen
                    </div>
                    <div class="clr-col-9"><br />{{ payment_condition }}</div>
                  </div>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      <br />Rechnungsbetrag
                    </div>
                    <div class="clr-col-9"><br /><b>{{ (nettoTotal*1.19) | number:'1.2-2' }} EUR</b> ({{ nettoTotal | number:'1.2-2' }} EUR netto)</div>
                  </div>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      Fällig am
                    </div>

                    <div *ngIf="!editDueDate" class="clr-col-9">
                      <span *ngIf="payment_term_value > 0">mit {{ payment_term_value }}% Skonto am {{ calculateDiscountDate(payment_term_date) }}</span>
                      {{ invoices.dateII | date: "dd.MM.yyyy" }}
                    </div>
                    <div *ngIf="editDueDate" class="clr-col-3">
                      <app-invoice-duedate [dueDate]="invoices.dateII" [praefix]="praefix" [invoiceId]="invoiceId" (updatedDate)="updateDueDate($event)">
                      </app-invoice-duedate>
                    </div>
                    <div *ngIf="editDueDate" class="clr-col-6"></div>
                  </div>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      <br />Bezahlt
                    </div>

                    <div *ngIf="!editAmount" class="clr-col-9">
                      <ng-container *ngIf="invoices.paid > 0">
                        <br />{{ invoices.paid | currency: "EUR" }} am {{ invoices.dateIII | date: "dd.MM.yyyy" }}
                        <br *ngIf="invoices.status === 'partially'" />(noch offener Betrag {{ openSkontoAmount() | currency: 'EUR':'code':'1.2-2':'de' }}/{{ openBruttoAmount() | currency: 'EUR':'code':'1.2-2':'de' }} (Skonto/Brutto))
                      </ng-container>
                      <ng-container *ngIf="invoices.paid === 0"><br />---</ng-container>
                    </div>
                    <div *ngIf="editAmount" class="clr-col-9">
                      <app-invoice-paid [paidDate]="invoices.dateIII" [praefix]="praefix" [invoiceId]="invoiceId" [saldo]="invoices.paid" (updatedPaid)="onPaidUpdated($event)"></app-invoice-paid>
                    </div>
                  </div>
                  <br />
                  <div class="btn-group btn-sm btn-primary">
                    <button class="btn btn-primary btn-sm" (click)="editDueDate = true; editAmount = false" *ngIf="!editDueDate">Bearbeiten</button>
                    <button class="btn btn-primary btn-sm" (click)="editDueDate = false; editAmount = true" *ngIf="editDueDate">Bearbeiten beenden</button>
                    <button class="btn btn-warning btn-sm" [disabled]="!isCancellable()" (click)="cancelInvoice(projectId, praefix, invoiceId, deliveryId)">Stornieren</button>
                    <button class="btn btn-danger btn-sm" [disabled]="!isDraft()" (click)="deleteInvoice(projectId, praefix, invoiceId, deliveryId)">Löschen</button>
                    <button class="btn btn-primary btn-sm" *ngIf="isPaymentEditable()" (click)="editAmount = true; editDueDate = false">Zahlungseingang</button>
                  </div>

                  <clr-datagrid *ngIf="editPos < 2 && !!positions" [clrDgLoading]="loading2" [(clrDgSelected)]="selected" [clrDgRowSelection]="true">
                    <clr-checkbox-wrapper class="clr-checkbox-wrapper">
                      <input clrcheckbox="" type="checkbox" aria-label="Select All" id="clr-form-control-54" class="ng-untouched ng-pristine ng-valid">
                      <label class="clr-control-label ng-star-inserted" for="clr-form-control-54"></label>
                    </clr-checkbox-wrapper>
                    <clr-dg-column [clrDgField]="'project_id'">Position</clr-dg-column>
                    <clr-dg-column>Bezeichnung</clr-dg-column>
                    <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
                    <clr-dg-column>Material</clr-dg-column>
                    <clr-dg-column>Kennzeichnung</clr-dg-column>
                    <clr-dg-column>Spezifikation/Bemerkungen</clr-dg-column>
                    <clr-dg-column>Lieferschein</clr-dg-column>
                    <clr-dg-column>Anzahl</clr-dg-column>
                    <clr-dg-column>EK-Preis/Stck.</clr-dg-column>
                    <clr-dg-column>VK-Preis/Stck.</clr-dg-column>
                    <clr-dg-column>VK-Preis/ges.</clr-dg-column>
                    <clr-dg-column *ngIf="editPos > 0"></clr-dg-column>
                    <clr-dg-placeholder>We couldn't find any Position for Invoice {{ invoices.praefix }}.{{ invoices.number }}!</clr-dg-placeholder>
                    <clr-dg-row *clrDgItems="let position of positions; index as i" [clrDgItem]="i">
                      <clr-checkbox-wrapper class="clr-checkbox-wrapper">
                        <input clrcheckbox="" type="checkbox" aria-label="Select" id="clr-dg-row-cb31" class="ng-untouched ng-pristine ng-valid">
                        <label class="clr-control-label ng-star-inserted" for="clr-dg-row-cb31"></label>
                      </clr-checkbox-wrapper>
                      <clr-dg-cell>{{ position.position }}<span *ngIf="position.part > 0">.{{ position.part }}</span> </clr-dg-cell>
                      <clr-dg-cell>
                        <b>{{ position.name }}</b>
                        <clr-tooltip *ngIf="position.comment_phm">
                          <cds-icon clrTooltipTrigger role="img" shape="info-circle" size="24" aria-label="PHM comment tooltip"></cds-icon>
                          <clr-tooltip-content clrPosition="bottom-right" clrSize="md" *clrIfOpen>
                            <span>{{ position.comment_phm }}</span>
                          </clr-tooltip-content>
                        </clr-tooltip>
                        <span *ngIf="position.description"><br />{{ position.description }}</span>
                        <span *ngIf="position.taric && position.taric !== '0'"><br />(Zolltarifnummer: {{ position.taric }})</span>
                      </clr-dg-cell>
                      <clr-dg-cell>{{ position.technical_drawing }}</clr-dg-cell>

                      <clr-dg-cell>{{ position.material }}
                        <span class="small" *ngIf="position.heat_nr !== 'null'"><br /><br />{{ position.heat_nr }}</span>
                        <span class="small" *ngIf="position.controlling_nr !== 'null'"><br *ngIf="((!position.heat_nr) || (position.heat_nr === 'null') || (position.heat_nr === ''))" /><br />{{ position.controlling_nr }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell>{{ position.serial_nr }}</clr-dg-cell>
                      <clr-dg-cell>
                        <span *ngIf="position.specification"><b>Spezifikation:</b> {{ position.specification }}<br /><br /></span>
                        <span *ngIf="position.remarks"><b>Leistungsumfang:</b> {{ position.remarks }}<br /><br /></span>
                        <span *ngIf="position.side_agreements"><b>Nebenabreden (Kunde):</b> {{ position.side_agreements }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell [routerLink]="['/delivery/details', projectId, jobId, deliveryId]">{{ invoices.project_id + ".0004." + invoices.delivery_id }}</clr-dg-cell>
                      <clr-dg-cell class="center"><span *ngIf="!position.technology"> {{ position.number_of_pieces }} </span></clr-dg-cell>
                      <clr-dg-cell class="right">{{ position.purchasing_price  | currency: 'EUR':'code':'1.2-2':'de' }}</clr-dg-cell>
                      <clr-dg-cell class="right">{{ position.selling_price  | currency: 'EUR':'code':'1.2-2':'de' }}</clr-dg-cell>
                      <clr-dg-cell class="right"><b>{{ (+position.selling_price) * (+position.number_of_pieces)  | currency: 'EUR':'code':'1.2-2':'de' }}</b></clr-dg-cell>
                      <clr-dg-cell class="btn-group btn-primary btn-icon" minlength="300px" *ngIf="editPos > 0">
                        <button class="btn btn-sm" (click)="updatePositionMode(i, position.position, position.part)">
                          <cds-icon shape="pencil"></cds-icon>
                          <span class="clr-icon-title">Ändern</span>
                        </button>
                        <button class="btn btn-warning btn-sm" (click)="deletePosition(praefix + '.' + invoiceId, position.position, position.part)">
                          <cds-icon shape="times"></cds-icon>
                          <span class="clr-icon-title">Löschen</span>
                        </button>
                      </clr-dg-cell>
                    </clr-dg-row>
                    <clr-dg-footer>
                      <clr-dg-pagination #pagination [clrDgPageSize]="50">
                        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Positionen pro Seite</clr-dg-page-size>
                        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
                        von {{positions.length}} Position(en)
                      </clr-dg-pagination>
                    </clr-dg-footer>
                  </clr-datagrid>

                  <app-invoice-edit-position [projectNumber]="projectId" [offerNumber]="invoiceId" [editPosition]="positionId" [editPart]="partId" *ngIf="editPos === 2"  (updatedPosition)="updateInvoice($event)"></app-invoice-edit-position>

                  <br />
                  <div class="btn-group btn-sm btn-primary">
                    <button [disabled]="!printInvoice" class="btn btn-primary btn-sm" (click)="basic = true; createInvoice(positions)">PDF anzeigen</button>
                    <button [disabled]="!printInvoice"  *ngIf="editPos === 0" class="btn btn-primary btn-sm" (click)="downloadXInv();">XRechnung*</button>
                    <button [disabled]="true"  *ngIf="editPos === 0" class="btn btn-primary btn-sm" (click)="downloadZFerD();" >ZUGFeRD</button>
                  </div>
                  <p class="small">* BITTE BEACHTEN: Die Spezifikation der XRechnung wurde initial auf die Vorgaben der <a href="https://xre.deutschebahn.com" target="_blank">Deutschen Bahn</a> implementiert. </p>
                </clr-tab-content>
              </clr-tab>

              <clr-tab>
                <button clrTabLink>Dokumente</button>
                <clr-tab-content clrTabContentId="content2" *clrIfActive>
                  <app-invoice-details-documents [projectId]="projectId" [jobId]="jobId"></app-invoice-details-documents>
                </clr-tab-content>
              </clr-tab>
            </clr-tabs>
          </div>
        </div>
        <div class="card-footer">
          <small>Projektverantwortlich:  {{ staffFirstName }} {{ staffLastName }} ({{ invoices.employee_phm }})</small>
        </div>
      </div>
    </div>
  </div>
</main>

<clr-modal [(clrModalOpen)]="basic" [clrModalSize]="'xl'">
  <h3 class="modal-title">RECHNUNG {{ invoices.praefix }}.{{ invoices.number }}</h3>
  <div id="documentContainer" class="modal-body"></div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="basic = false">Zurück</button>
    <button type=“button” class="btn btn-primary" (click)="downloadPdf(); basic = false">Download</button>
    <button type="button" class="btn btn-primary" (click)="archivePdf(); basic = false">Archivieren</button>
    <button type="button" class="btn btn-primary" (click)="printPdf(); basic = false">Drucken</button>
  </div>
</clr-modal>

<pre *ngIf="devMode" class="datepicker-output">
{{ invoices | json }}
</pre>

<pre *ngIf="devMode" class="datepicker-output">
    {{ person | json }}
</pre>

<pre *ngIf="devMode" class="datepicker-output">
    {{ xInvoice | json }}
</pre>
